import { Component, Input } from '@angular/core';
import { DatasetColumn } from '../select-datasource-modal.model';

@Component({
  selector: 'app-dataset-column-table',
  standalone: false,
  templateUrl: './dataset-column-table.component.html',
  styleUrl: './dataset-column-table.component.scss'
})
export class DatasetColumnTableComponent {
  @Input() columns: DatasetColumn[] = [];
  @Input() loading = false;

  trackByColumnKey(_: number, column: DatasetColumn): string {
    return column.key;
  }
}
